'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _semanticUiReact = require('semantic-ui-react');

var _storiesIcon = require('./stories-icon.png');

var _storiesIcon2 = _interopRequireDefault(_storiesIcon);

var _instagramStory = require('../instagram-story');

var _instagramStory2 = _interopRequireDefault(_instagramStory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var InstagramStories = function InstagramStories(props) {
  var isLoading = props.isLoading,
      hasFailed = props.hasFailed,
      stories = props.stories,
      emptyMessageText = props.emptyMessageText,
      campaignList = props.campaignList,
      onCampaignSelected = props.onCampaignSelected;

  return _react2.default.createElement(
    _semanticUiReact.Segment,
    { basic: true },
    isLoading && !hasFailed && _react2.default.createElement(_semanticUiReact.Loader, {
      active: true,
      style: { marginTop: '32px' },
      content: 'Loading...'
    }),
    _react2.default.createElement(
      _semanticUiReact.Card.Group,
      { itemsPerRow: 1 },
      !isLoading && !hasFailed && _lodash2.default.map(stories, function (story) {
        return _react2.default.createElement(_instagramStory2.default, (0, _extends3.default)({}, story, {
          campaignList: campaignList,
          onCampaignSelected: onCampaignSelected
        }));
      }),
      !isLoading && hasFailed && _react2.default.createElement(_semanticUiReact.Message, {
        icon: 'ban',
        error: true,
        fluid: true,
        content: 'Could not load stories. Please try again later.'
      }),
      !isLoading && !hasFailed && _lodash2.default.size(stories) === 0 && _react2.default.createElement(
        _semanticUiReact.Message,
        { style: { marginTop: '64px' }, icon: true, info: true },
        _react2.default.createElement(_semanticUiReact.Image, { style: { marginRight: '10px' }, src: _storiesIcon2.default, size: 'tiny' }),
        _react2.default.createElement(
          _semanticUiReact.Message.Content,
          null,
          emptyMessageText
        )
      )
    )
  );
};

exports.default = InstagramStories;


/*****************
 ** WEBPACK FOOTER
 ** ./~/dyzio-shared-components/lib/components/instagram-stories/index.js
 ** module id = 2580
 ** module chunks = 0
 **/